<template>
  <div class="readme-container">
    <div class="text-blue-light text-bold italic pb-8 border-b border-grey-light">Day 1833. Have been dwelling much on past lately. Strange occurrences in PATRICIA system like ones we have been experiencing have not occurred since before Day 0. Have pulled personal logs from time period surrounding Day 0 for closer examination. I must admit, they pain me to read. Dates have been altered to reflect new standard calendar.</div>
    <div
      v-for="item in items"
      :key="item.day"
      class="py-8 border-b border-grey-light"
    >
      <div class="text-blue-lighter text-2xl">DAY: {{ item.day }}</div>
      <div class="text-blue mt-4">{{ item.text }}</div>
      <div
        v-if="item.text2"
        class="text-blue mt-4"
      >
        {{ item.text2 }}
      </div>
      <div
        v-if="item.text3"
        class="text-blue mt-4"
      >
        {{ item.text3 }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Readme',

  data() {
    return {
      items: [
        {
          day: '-76',
          text:
            'Laila and her pet computer are still none the wiser to backdoor system. Will be storing data here like squirrel, just in case. Too many people in this base now, not like old days. Must keep some things to myself. ',
        },
        {
          day: '-72',
          text:
            'Deep space transmissions Laila has been tracking continue to increase in frequency. We have never seen anything like them before. ',
        },
        {
          day: '-68',
          text:
            'Meaning of transmissions still unclear. Whatever is sending them is very, very big. Is on direct course for Earth. Approximate arrival is less than three months from today. ',
        },
        {
          day: '-63',
          text:
            'Mathias, Laila, and myself have not slept in days. Computer working overtime to decode transmissions. No progress. ',
        },
        {
          day: '-60',
          text:
            'There has been attempted breach in P.A.T.R.I.C.I.A.’s firewall. As if we did not have enough to worry about. Connected to transmissions? ',
        },
        {
          day: '-56',
          text:
            'Another attempted breach. Much closer to success this time, but I was able to fend it off. Must find this attacker as soon as possible. If P.A.T.R.I.C.I.A. were to be compromised, there is no telling amount of destruction she would bring to us.',
        },
        {
          day: '-55',
          text:
            'Have confirmed: attacks not connected to transmissions. Seem to be coming from single party, situated on planet Earth. Wish that I could provide more specific location than that. ',
        },
        {
          day: '-52',
          text:
            'Requested facility begin preparing for Omega Protocol scenario in light of most recent readings.',
        },
        {
          day: '-51',
          text: 'Request denied. ',
        },
        {
          day: '-49',
          text:
            'Third attempted cyber attack. Hacker picked terrible time to mess with us. Too much happening now to focus on apprehending criminal. Outsourcing investigation to American Federal Bureau. ',
        },
        {
          day: '-48',
          text:
            'Man named Shepard Oswald assigned to cyberattack case. He is currently in Europe, will be en route to America in twelve hours. Have done preliminary background scan on him and compiled file of basic information. He is very high on food chain. Much information about him is redacted.',
        },
        {
          day: '-45',
          text:
            'Most recent readings suggest it is even larger than we thought. Omega Protocol being discussed more seriously. It is about time. In old days, when mutually assured destruction was on everyone’s minds, Omega Protocol would have happened weeks ago. The younger people are complacent. They have not seen what I have seen.',
        },
        {
          day: '-41',
          text:
            'Have been focusing on establishing secure NACS facility intranet for inevitable event of facility’s outside contact with world being cut to prevent leaks. Usually Laila would be head of such a task, but her hands are more than full with transmissions.',
          text2:
            'Have taken liberty of adding several access points to my own personal data caches throughout NACS intranet. I will not be around forever, but things I know should not disappear with me. Someone, perhaps Laila, will find them one day. ',
        },
        {
          day: '-39',
          text:
            'I am selfishly happy that I rank highly enough to have Nina and our children brought in. There are some benefits to having spent decades of life in this place after all. Am very impatient for call to be made. If it would not have us all barred from this place for life, I would send for them this instant. ',
        },
        {
          day: '-38',
          text:
            'Intranet task distracted me. I became careless. Hacker managed to breach security. New incident report sent to Agent Oswald.',
          text2:
            'Amongst many other things, assailant now knows Omega Protocol is being discussed. If he goes to press with this particular fact, mass panic will erupt.',
        },
        {
          day: '-37',
          text:
            'Botanist by the name of Dr. Anthony Whelan has been brought in as contractor to ensure base’s self-sufficiency. He has not been told why, and I do not know if or when leadership plans to inform him. I hope for his sake they never do. He should be allowed to return to his family in blissful ignorance once this task is done. Even if Dr. Whelan is asked to stay, his family will not be. Policy is strict on that subject. That is not a choice any man should have to make. ',
        },
        {
          day: '-36',
          text:
            'Persephone has sent out massive order for years’ worth of medications. Hope that she took Mathias into account when budgeting for SSRIs.',
        },
        {
          day: '-35',
          text:
            'Cyril has been urging us all to speak with him to make sure that we are not all on verge of mental breakdown. He does not realize that there is no time for talking about feelings. ',
        },
        {
          day: '-34',
          text:
            'Mathias is running back and forth like headless chicken in order to prepare dormitories and long-term storage facilities. It is strange to see rooms once used to chart out international espionage strategies now brimming with canned beans. ',
        },
        {
          day: '-30',
          text:
            'High-ranking residents finally given permission to call their allotted next of kin. Nina and our children are packing their things.',
        },
        {
          day: '-29',
          text:
            'Received report from Oswald. He seems to think he is closing in. I pray he is right. The base cannot be compromised. One silver lining: whoever launched attack has not spoken to media as of yet.',
        },
        {
          day: '-28',
          text:
            'Sofiya, Bo, and Pavlo. My treasures. Nina, my joy. How I wish that our reunion did not have to be under these circumstances.',
          text2:
            'I know from way she looks at me now that Nina will never forgive me for telling her she could not bring her father and sisters here. It was not my call to make, I have explained to her.',
          text3:
            'Still, I celebrate that she and children came here in time. Whatever is about to happen, it will be bearable as long as we are together.',
        },
        {
          day: '-27',
          text:
            'Bo has already managed to make a friend. Little Augustus Lind is a small version of his father in every way. I did not know that children could be so fastidious. But he seems to relax around Bo. I think they will be good for one another.',
        },
        {
          day: '-25',
          text:
            'Oswald has identified a primary suspect, but will not tell me who. Requested Oswald send over his file on the case. In several weeks this may no longer matter. But still, is frustrating.',
        },
        {
          day: '-24',
          text:
            'Oswald has chosen to insult me by sending a file on suspect too redacted to be useful. I cannot gain access no matter which methods I employ.',
        },
        {
          day: '-23',
          text:
            'Frustrated enough about redacted file to ask P.A.T.R.I.C.I.A system for assistance in gaining access. Even it could not breach file security. So it says, at least. Has it already been compromised? ',
        },
        {
          day: '-20',
          text:
            'Oswald closing in on suspect. Source of signals closing in on planet. Everyone still scrambling to make sure that everything is in its place.',
        },
        {
          day: '-18',
          text:
            'Pavlo is asking questions I do not know answers to. “How long are we going to stay down here, Папа?”',
        },
        {
          day: '-15',
          text:
            'Preparations complete. Omega Protocol can now be deployed at any time. Leadership still ignoring me and dragging their feet. Do not understand why.  I have never steered them wrong before. Well, rarely. I think they do not want to believe that things are as bad as they are. I have seen many people die as a result of this type of thinking.',
        },
        {
          day: '-14',
          text:
            'Cyril informed Dr. Whelan of the true nature of his assignment in true Cyril fashion, crushing news delivered in gentlest voice possible. He gave him choice to stay or not. Dr. Whelan did not take it well.',
        },
        {
          day: '-10',
          text:
            'After much back and forth, Dr. Whelan has chosen to stay. He has excellent skills and many good ideas about genetic modification. His mind would be wasted on the surface. I will not judge his choice too harshly, but I would not have done the same. ',
        },
        {
          day: '-6',
          text:
            'Transmissions stronger than ever. Still indecipherable. Arriving in approximately 7-8 days.',
        },
        {
          day: '-5',
          text:
            'Oswald is tracking suspect’s location, is planning to make an arrest within the week. He tells me the suspect was much closer to base than I would have thought. Very bold of him. I do not have heart to tell Oswald his chase no longer matters. Even if I did, he does not have clearance to be informed as to why. It is funny, that I do not have clearance to be informed of his charge and he cannot be informed of mine.',
        },
        {
          day: '-3',
          text:
            'Last straggling family members of high ranking residents have finally arrived. Base at capacity. About time. Only three days remaining.  Now all we can do is wait and see what will happen.',
        },
        {
          day: '-1',
          text:
            'They are early. Death, destroyer of worlds, is visiting surface. All we can do is hold one another.',
        },
        {
          day: '0',
          text:
            'Omega Protocol enacted. About time. All of facility’s self-sustaining capabilities put fully online. All communications to outside world cut off. Distress calls from all continents no longer constantly playing. Leadership in debate over who will constitute A ranked officials. Do not trust any of them, based on how they have behaved.',
        },
        {
          day: '1',
          text:
            'Some people in facility are very sick. Something is wrong. We were so fixated on what would come on Day 0 that we did not stop to wonder if they would send anything out in front of them. Something too small to register on sensors. A virus. Last stragglers must have carried it in. Now it spreads amongst us here. First fatality has already occurred. Augustus was such a sweet boy. Persephone and small team of volunteers have been living in hazmat suits since first symptoms appeared, doing their best with what medication we have. Lab C has become a quarantine zone for the sick.',
        },
        {
          day: '2',
          text:
            'Over ninety percent of base appears to have been infected. Persephone has been leading all of them down to Lab C herself. Nina. Sofiya, Pavlo, and Bo amongst them. I trust Persephone to do her best to help them. I told them everything was going to be alright, and that Папа would come to visit as soon as he could. ',
        },
        {
          day: '3',
          text:
            'I promised them all that they would be safe here. I was wrong. And now, I am alone.',
          text2:
            'Persephone gave orders from inside Lab C that the entire base must undergo full decontamination. We only have resources to perform this feat once, although we will have enough materials to perform hundreds of decontamination procedures to individual residents if we ration carefully. Virus must not breach these doors again. ',
        },
        {
          day: '4',
          text:
            'At least one person survived the attacks on surface. Oswald showed up at our doorstep today. Underwent thorough individual decontamination and debrief. Oswald reportedly apprehended suspect several days ago. But main body of invasion hit while the two were en route to NACS facility. Suspect did not survive journey.',
          text2:
            'Persephone has finally emerged from Lab C, and from hazmat suit she has lived in for several days. She looks small and hungry and lost.',
        },
        {
          day: '6',
          text:
            'The population of base has gone from over one hundred to seven in a week. No members of top leadership survived. Besides myself, only Laila, Mathias, Cyril, Persephone, Dr. Whelan, and Agent Oswald remain. Today the seven of us worked to seal Lab C.',
        },
        {
          day: '8',
          text:
            'Cyril is pushing for us to sit in circles and talk about feelings. He did not have family. He will never understand.',
        },
        {
          day: '9',
          text:
            'Laila pointed out that as most senior living members, we are both Class A as far as Omega Protocol is concerned. As are Mathias, Persephone, and Cyril. I suppose us five are supposed to govern Oswald and Whelan now.',
        },
        {
          day: '10',
          text:
            'Persephone has refused leadership position and rescinded Class A status. I think she feels as though she failed by not saving population from virus. She does not look Mathias or myself in our eyes anymore. Dr. Whelan was next in line to be offered position. Also refused. Stated reason for refusal was that he wished to be able to focus on his work full time. Think he may resent our not giving him opportunity to contact his family. Or perhaps he feels himself unworthy of position for having abandoned them. Oswald accepted position in their places. ',
        },
        {
          day: '12',
          text:
            'More survivors arriving. Hikers who stumbled upon this place on their own. They underwent decontamination procedures before being allowed in. Persephone thinks that some people were immune to virus, though perhaps some were simply lucky. I do not feel lucky. ',
        },
        {
          day: '24',
          text:
            'This log only reminds me of how I failed my family. I will continue to update other files, but this particular one I leave alone for foreseeable future.',
        },
      ],
    }
  },
}
</script>

<style lang="postcss" scoped>
.readme-container {
  padding: 20px;
  font-family: 'input-mono';
}
</style>
